import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Grid from '@mui/material/Grid';
import Menu from '@mui/icons-material/Menu';

import Link from 'next/link';
import React from 'react';

import Confirmer from '../common/Confirmer';
import Notifier from '../common/Notifier';
import HomepageModal from '../common/HomepageModal';
import WeeklyUpdateModal from '../common/WeeklyUpdateModal';

function LayoutWrapper({
  children,
  isThemeDark,
  open,
  openNewsletterModal,
  openHomepageModal,
  currentRoute,
  component,
}: {
  children: React.ReactNode;
  isThemeDark: boolean;
  open: boolean;
  openNewsletterModal: boolean;
  openHomepageModal: boolean;
  currentRoute: string;
  component: any;
}) {
  return (
    <div
      style={{
        display: 'flex',
        minHeight: '100vh',
        flexDirection: 'column',
        justifyContent: 'space-between',
        overflowX: 'hidden',
      }}
    >
      <Grid
        container
        direction="row"
        justifyContent="space-around"
        alignItems="center"
        sx={{
          padding: { xs: '0px 0px 0px 12px', md: '11px 20px 10px 20px' },
          height: '64px',
          background: '#dce7f1',
          top: 0,
          zIndex: 1000,
        }}
      >
        <Grid item md={3} xs={10}>
          <Link href="/">
            <Box
              component="svg"
              sx={{
                cursor: 'pointer',
                marginLeft: { xs: '0px', md: '20px' },
                width: { xs: '220px', md: '256px' },
                height: { xs: '40px', md: '40px' },
              }}
              viewBox="0 0 256 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <Box
                component="path"
                d="M59.5869 13.0309H63.295C63.5198 13.7942 63.7658 14.6544 64.0332 15.6114C64.3044 16.5685 64.5931 17.5585 64.8992 18.5814C65.2053 19.6043 65.5172 20.6272 65.8349 21.6502C66.1487 22.6731 66.4548 23.6224 66.7532 24.4981C66.9973 23.5488 67.2433 22.5162 67.4913 21.4002C67.7432 20.2843 67.9815 19.1316 68.2062 17.9421C68.4271 16.7487 68.646 15.563 68.863 14.3851C69.0761 13.2033 69.2756 12.0642 69.4616 10.9676H73.9776C73.3266 14.203 72.5788 17.4849 71.7341 20.8132C70.8894 24.1416 69.9731 27.3033 68.985 30.2985H64.998C64.347 28.5122 63.7135 26.6388 63.0974 24.6782C62.4852 22.7138 61.8808 20.7474 61.2841 18.779C60.6912 20.7474 60.0965 22.7138 59.4998 24.6782C58.9069 26.6388 58.2851 28.5122 57.6341 30.2985H53.6412C52.6571 27.3033 51.7407 24.1416 50.8921 20.8132C50.0474 17.4849 49.2996 14.203 48.6487 10.9676H53.3622C53.5482 12.0642 53.7536 13.2033 53.9783 14.3851C54.1992 15.563 54.4317 16.7487 54.6758 17.9421C54.916 19.1316 55.162 20.2843 55.4139 21.4002C55.6658 22.5162 55.9215 23.5488 56.1811 24.4981C56.5143 23.5836 56.8398 22.615 57.1575 21.592C57.4752 20.5691 57.7813 19.5462 58.0758 18.5233C58.3742 17.5004 58.6493 16.5162 58.9011 15.5708C59.153 14.6215 59.3816 13.7748 59.5869 13.0309ZM90.2187 22.9346C90.2187 24.0854 90.0502 25.1413 89.7131 26.1022C89.3799 27.0592 88.8975 27.8768 88.2659 28.5549C87.6304 29.2329 86.871 29.758 85.9876 30.1299C85.1041 30.5019 84.1142 30.6879 83.0176 30.6879C81.9405 30.6879 80.9602 30.5019 80.0767 30.1299C79.1933 29.758 78.4358 29.2329 77.8042 28.5549C77.1688 27.8768 76.6747 27.0592 76.3221 26.1022C75.9696 25.1413 75.7933 24.0854 75.7933 22.9346C75.7933 21.78 75.9754 20.728 76.3396 19.7787C76.6999 18.8333 77.2017 18.0254 77.8449 17.3551C78.4842 16.6847 79.2456 16.1636 80.129 15.7916C81.0125 15.4197 81.9753 15.2337 83.0176 15.2337C84.0793 15.2337 85.0518 15.4197 85.9353 15.7916C86.8187 16.1636 87.5762 16.6847 88.2078 17.3551C88.8394 18.0254 89.3314 18.8333 89.684 19.7787C90.0405 20.728 90.2187 21.78 90.2187 22.9346ZM85.976 22.9346C85.976 21.6521 85.7202 20.6427 85.2088 19.9065C84.6973 19.1704 83.9669 18.8023 83.0176 18.8023C82.0683 18.8023 81.3341 19.1704 80.8149 19.9065C80.2957 20.6427 80.036 21.6521 80.036 22.9346C80.036 24.2171 80.2957 25.2343 80.8149 25.9859C81.3341 26.7415 82.0683 27.1193 83.0176 27.1193C83.9669 27.1193 84.6973 26.7415 85.2088 25.9859C85.7202 25.2343 85.976 24.2171 85.976 22.9346ZM102.968 15.873L102.271 19.3079C101.899 19.2149 101.461 19.1161 100.957 19.0115C100.453 18.9108 99.9148 18.8604 99.3413 18.8604C99.0779 18.8604 98.7659 18.8836 98.4056 18.9301C98.0414 18.9766 97.7663 19.027 97.5803 19.0812V30.2985H93.4247V16.4077C94.1686 16.1442 95.0482 15.8962 96.0633 15.6638C97.0746 15.4313 98.2041 15.315 99.4518 15.315C99.6726 15.315 99.9419 15.3305 100.26 15.3615C100.577 15.3887 100.893 15.4255 101.207 15.472C101.525 15.5185 101.841 15.5746 102.154 15.6405C102.472 15.7025 102.743 15.78 102.968 15.873ZM109.353 8.64862V20.9237C109.764 20.4781 110.188 20.0131 110.626 19.5288C111.06 19.0444 111.482 18.5659 111.893 18.0932C112.304 17.6205 112.689 17.1691 113.05 16.739C113.414 16.3128 113.726 15.9408 113.985 15.6231H118.926C117.938 16.7584 116.975 17.8413 116.037 18.872C115.095 19.9065 114.067 20.9721 112.951 22.0686C113.509 22.5723 114.086 23.1729 114.683 23.8704C115.28 24.5678 115.857 25.2885 116.415 26.0324C116.973 26.7764 117.484 27.5203 117.949 28.2643C118.414 29.0082 118.804 29.6863 119.117 30.2985H114.346C114.051 29.8141 113.712 29.2794 113.329 28.6944C112.949 28.1093 112.544 27.5242 112.114 26.9391C111.688 26.3502 111.238 25.7864 110.765 25.2478C110.289 24.7092 109.818 24.254 109.353 23.882V30.2985H105.198V9.31701L109.353 8.64862ZM132.201 15.6231V30.2985H128.046V15.6231H132.201ZM132.591 11.3861C132.591 12.1455 132.345 12.7442 131.853 13.182C131.361 13.6199 130.779 13.8388 130.109 13.8388C129.439 13.8388 128.858 13.6199 128.366 13.182C127.873 12.7442 127.627 12.1455 127.627 11.3861C127.627 10.6228 127.873 10.0222 128.366 9.58436C128.858 9.14652 129.439 8.9276 130.109 8.9276C130.779 8.9276 131.361 9.14652 131.853 9.58436C132.345 10.0222 132.591 10.6228 132.591 11.3861ZM136.108 30.2985V16.1287C136.814 15.9234 137.724 15.7316 138.84 15.5533C139.956 15.379 141.128 15.2918 142.356 15.2918C143.604 15.2918 144.64 15.4545 145.466 15.78C146.295 16.1055 146.952 16.5646 147.436 17.1575C147.92 17.7542 148.263 18.4613 148.465 19.2788C148.67 20.0964 148.773 21.007 148.773 22.0105V30.2985H144.617V22.5162C144.617 21.1755 144.441 20.2262 144.088 19.6683C143.736 19.1103 143.075 18.8313 142.106 18.8313C141.808 18.8313 141.492 18.8449 141.159 18.872C140.822 18.903 140.524 18.9359 140.264 18.9708V30.2985H136.108Z"
                sx={{ fill: isThemeDark ? 'white' : '#000' }}
              />
              <Box
                component="path"
                d="M168.323 22.8474C168.323 20.17 167.337 18.8313 165.365 18.8313C164.934 18.8313 164.51 18.8875 164.092 18.9999C163.673 19.1122 163.334 19.2517 163.075 19.4183V26.9798C163.28 27.0147 163.541 27.0476 163.859 27.0786C164.173 27.1057 164.516 27.1193 164.888 27.1193C166.023 27.1193 166.88 26.7279 167.457 25.9453C168.034 25.1664 168.323 24.1338 168.323 22.8474ZM172.56 22.9637C172.56 24.1338 172.387 25.1936 172.043 26.1429C171.702 27.0922 171.206 27.9 170.555 28.5665C169.904 29.2368 169.104 29.7541 168.154 30.1183C167.205 30.4787 166.126 30.6588 164.917 30.6588C164.413 30.6588 163.888 30.6356 163.342 30.5891C162.792 30.5426 162.251 30.4825 161.72 30.4089C161.193 30.3353 160.688 30.2481 160.203 30.1474C159.719 30.0428 159.291 29.9343 158.919 29.8219V9.31701L163.075 8.64862V15.9602C163.54 15.7548 164.024 15.5959 164.528 15.4836C165.027 15.3712 165.566 15.315 166.143 15.315C167.186 15.315 168.106 15.4971 168.904 15.8614C169.706 16.2256 170.376 16.7409 170.915 17.4074C171.454 18.0777 171.862 18.8836 172.141 19.8252C172.42 20.7629 172.56 21.809 172.56 22.9637ZM179.925 15.6231V30.2985H175.769V15.6231H179.925ZM180.314 11.3861C180.314 12.1455 180.068 12.7442 179.576 13.182C179.084 13.6199 178.503 13.8388 177.832 13.8388C177.162 13.8388 176.581 13.6199 176.089 13.182C175.597 12.7442 175.351 12.1455 175.351 11.3861C175.351 10.6228 175.597 10.0222 176.089 9.58436C176.581 9.14652 177.162 8.9276 177.832 8.9276C178.503 8.9276 179.084 9.14652 179.576 9.58436C180.068 10.0222 180.314 10.6228 180.314 11.3861ZM197.56 22.9346C197.56 24.0854 197.391 25.1413 197.054 26.1022C196.721 27.0592 196.238 27.8768 195.607 28.5549C194.971 29.2329 194.212 29.758 193.329 30.1299C192.445 30.5019 191.455 30.6879 190.359 30.6879C189.281 30.6879 188.301 30.5019 187.418 30.1299C186.534 29.758 185.777 29.2329 185.145 28.5549C184.51 27.8768 184.016 27.0592 183.663 26.1022C183.311 25.1413 183.134 24.0854 183.134 22.9346C183.134 21.78 183.316 20.728 183.681 19.7787C184.041 18.8333 184.543 18.0254 185.186 17.3551C185.825 16.6847 186.587 16.1636 187.47 15.7916C188.353 15.4197 189.316 15.2337 190.359 15.2337C191.42 15.2337 192.393 15.4197 193.276 15.7916C194.16 16.1636 194.917 16.6847 195.549 17.3551C196.18 18.0254 196.672 18.8333 197.025 19.7787C197.382 20.728 197.56 21.78 197.56 22.9346ZM193.317 22.9346C193.317 21.6521 193.061 20.6427 192.55 19.9065C192.038 19.1704 191.308 18.8023 190.359 18.8023C189.409 18.8023 188.675 19.1704 188.156 19.9065C187.637 20.6427 187.377 21.6521 187.377 22.9346C187.377 24.2171 187.637 25.2343 188.156 25.9859C188.675 26.7415 189.409 27.1193 190.359 27.1193C191.308 27.1193 192.038 26.7415 192.55 25.9859C193.061 25.2343 193.317 24.2171 193.317 22.9346ZM200.626 24.3005V11.9673L204.782 11.2989V15.6231H209.774V19.0812H204.782V24.2423C204.782 25.118 204.935 25.8155 205.241 26.3347C205.551 26.8578 206.171 27.1193 207.101 27.1193C207.546 27.1193 208.006 27.0767 208.478 26.9914C208.955 26.9101 209.387 26.7938 209.774 26.6427L210.361 29.88C209.862 30.0854 209.304 30.2617 208.687 30.4089C208.075 30.56 207.322 30.6356 206.427 30.6356C205.295 30.6356 204.358 30.4806 203.614 30.1706C202.87 29.8645 202.273 29.4383 201.823 28.892C201.378 28.3418 201.068 27.6753 200.894 26.8926C200.715 26.1138 200.626 25.2498 200.626 24.3005ZM211.897 23.0741C211.897 21.7722 212.096 20.6331 212.496 19.6566C212.895 18.6802 213.42 17.8665 214.071 17.2156C214.722 16.5646 215.471 16.0706 216.32 15.7335C217.165 15.4003 218.034 15.2337 218.929 15.2337C221.01 15.2337 222.655 15.8711 223.864 17.1458C225.073 18.4206 225.677 20.294 225.677 22.7661C225.677 23.0063 225.668 23.2717 225.648 23.5623C225.633 23.8491 225.615 24.1048 225.596 24.3295H216.163C216.256 25.1858 216.657 25.8639 217.366 26.3637C218.071 26.8674 219.019 27.1193 220.208 27.1193C220.971 27.1193 221.721 27.0495 222.457 26.9101C223.19 26.7706 223.788 26.5981 224.253 26.3928L224.811 29.7696C224.59 29.882 224.294 29.9924 223.922 30.1009C223.55 30.2132 223.135 30.312 222.678 30.3973C222.225 30.4787 221.737 30.5484 221.214 30.6065C220.694 30.6608 220.173 30.6879 219.65 30.6879C218.333 30.6879 217.186 30.4922 216.209 30.1009C215.233 29.7134 214.423 29.1787 213.78 28.4967C213.137 27.8187 212.662 27.0147 212.356 26.0847C212.05 25.1548 211.897 24.1513 211.897 23.0741ZM216.163 21.4816H221.661C221.642 21.129 221.582 20.7861 221.481 20.4529C221.376 20.1158 221.217 19.8174 221.004 19.5578C220.791 19.2982 220.522 19.0851 220.196 18.9185C219.871 18.748 219.466 18.6628 218.982 18.6628C218.517 18.6628 218.118 18.7422 217.784 18.9011C217.447 19.0599 217.168 19.2692 216.948 19.5288C216.723 19.7884 216.55 20.0906 216.43 20.4354C216.31 20.7803 216.221 21.129 216.163 21.4816ZM228.189 22.9637C228.189 21.902 228.362 20.9023 228.706 19.9647C229.051 19.0231 229.549 18.2036 230.2 17.5062C230.851 16.8087 231.642 16.2566 232.571 15.8497C233.501 15.439 234.561 15.2337 235.751 15.2337C236.529 15.2337 237.244 15.3034 237.895 15.4429C238.546 15.5824 239.18 15.7819 239.796 16.0415L238.93 19.3602C238.539 19.213 238.11 19.0832 237.645 18.9708C237.18 18.8584 236.659 18.8023 236.082 18.8023C234.858 18.8023 233.943 19.1839 233.339 19.9472C232.734 20.7105 232.432 21.716 232.432 22.9637C232.432 24.2811 232.715 25.304 233.281 26.0324C233.846 26.757 234.836 27.1193 236.251 27.1193C236.754 27.1193 237.295 27.0728 237.872 26.9798C238.446 26.8868 238.974 26.7376 239.459 26.5323L240.046 29.9381C239.561 30.1396 238.957 30.3159 238.232 30.467C237.508 30.6143 236.708 30.6879 235.832 30.6879C234.495 30.6879 233.343 30.4883 232.374 30.0892C231.405 29.6902 230.611 29.1458 229.991 28.4561C229.367 27.7702 228.91 26.9566 228.619 26.015C228.333 25.0773 228.189 24.0602 228.189 22.9637ZM246.991 30.2985H242.836V9.31701L246.991 8.64862V15.6812C247.27 15.5882 247.629 15.4991 248.066 15.4138C248.504 15.3325 248.927 15.2918 249.333 15.2918C250.527 15.2918 251.519 15.4545 252.309 15.78C253.1 16.1055 253.731 16.5646 254.204 17.1575C254.677 17.7542 255.012 18.4613 255.209 19.2788C255.403 20.0964 255.5 21.007 255.5 22.0105V30.2985H251.344V22.5162C251.344 21.1755 251.172 20.2262 250.827 19.6683C250.482 19.1103 249.845 18.8313 248.915 18.8313C248.543 18.8313 248.194 18.8643 247.869 18.9301C247.543 18.996 247.251 19.0657 246.991 19.1394V30.2985Z"
                sx={{ fill: isThemeDark ? 'white' : '#000' }}
              />
              <Box component="circle" cx="20" cy="20" r="20" sx={{ fill: isThemeDark ? 'white' : '#000' }} />
              <Box
                component="path"
                d="M23.8545 23.1331L25.8702 14.3792H28.6475L25.1905 27.0588H22.8467L20.128 18.3518L17.4561 27.0588H15.1123L11.6436 14.3792H14.4209L16.4717 23.0393L19.0733 14.3792H21.2178L23.8545 23.1331Z"
                sx={{ fill: isThemeDark ? '#000' : 'white' }}
              />
            </Box>
          </Link>
        </Grid>

        <Grid item md={9} xs={2} style={{ textAlign: 'right' }}>
          <Box sx={{ display: { xs: 'block', md: 'none' } }}>
            <Menu onClick={() => component.toggleDrawer(true)} style={{ marginRight: '10px' }} />
            <Drawer anchor="right" open={open} onClose={() => component.toggleDrawer(false)}>
              <div style={{ background: '#dce7f1', width: '250px', height: '100%' }}>
                <p />
                <a
                  style={{ margin: '10px 20px', cursor: 'pointer', display: 'block' }}
                  onClick={() => component.toggleNewsletterModal(true)}
                >
                  Weekly update
                </a>
                <p />
                <Link
                  style={{ margin: '10px 20px', display: 'block' }}
                  onClick={() => component.toggleDrawer(false)}
                  href="/companies"
                  as="/companies"
                >
                  Companies
                </Link>
                <p />
                <Link
                  style={{ margin: '10px 20px', display: 'block' }}
                  onClick={() => component.toggleDrawer(false)}
                  href="/recruit"
                  as="/recruit"
                >
                  Recruit
                </Link>
                <p />

                <Link
                  style={{ margin: '10px 20px', display: 'block' }}
                  onClick={() => component.toggleDrawer(false)}
                  href="/promote"
                  as="/promote"
                >
                  Promote
                </Link>
                <p />
                <a
                  style={{ margin: '10px 20px', display: 'block' }}
                  href="https://workintalent.com?ref=wib"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Work In Talent
                </a>
                <p />
                <a
                  style={{ margin: '10px 20px', display: 'block' }}
                  href="https://findharbor.com?ref=wib"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Harbor ATS/CRM
                </a>
              </div>
            </Drawer>
          </Box>

          <Box sx={{ display: { xs: 'none', md: 'block' }, marginTop: '-5px' }} id="main-navigation">
            <a style={{ margin: '10px 20px', cursor: 'pointer' }} onClick={() => component.toggleNewsletterModal(true)}>
              Weekly update
            </a>
            |
            <Link
              style={{
                borderBottom:
                  currentRoute === '/companies' ? (isThemeDark ? '1px solid #fff' : '1px solid #000') : 'none',
                paddingBottom: currentRoute === '/companies' ? '2px' : '0px',
                margin: '10px 20px',
              }}
              href="/companies"
              as="/companies"
            >
              Companies
            </Link>
            |
            <Link
              style={{
                borderBottom:
                  currentRoute === '/recruit' ? (isThemeDark ? '1px solid #fff' : '1px solid #000') : 'none',
                paddingBottom: currentRoute === '/recruit' ? '2px' : '0px',
                margin: '10px 20px',
              }}
              onClick={() => component.toggleDrawer(false)}
              href="/recruit"
              as="/recruit"
            >
              Recruit
            </Link>
            |
            <Link
              style={{
                borderBottom:
                  currentRoute === '/promote' ? (isThemeDark ? '1px solid #fff' : '1px solid #000') : 'none',
                paddingBottom: currentRoute === '/promote' ? '2px' : '0px',
                margin: '10px 20px',
              }}
              href="/promote"
              as="/promote"
            >
              Promote
            </Link>
            |
            <a
              style={{ margin: '10px 20px' }}
              href="https://workintalent.com?ref=wib"
              target="_blank"
              rel="noopener noreferrer"
            >
              Work In Talent
            </a>
            |
            <a
              style={{ margin: '10px 20px' }}
              href="https://findharbor.com?ref=wib"
              target="_blank"
              rel="noopener noreferrer"
            >
              Harbor ATS/CRM
            </a>
          </Box>
        </Grid>
      </Grid>
      {children}
      {currentRoute === '/recruit' ? null : (
        <>
          <p />
          <br />
        </>
      )}
      <Grid
        container
        direction="row"
        justifyContent="space-around"
        alignItems={{ xs: 'center', md: 'stretch' }}
        sx={{
          padding: { xs: '20px', md: '30px 10% 30px 25%' },
          background: isThemeDark ? '#000' : '#dce7f1',
          display: currentRoute.includes('/job') ? 'none' : 'inherit',
        }}
      >
        <Grid item md={6} xs={12}>
          <Box sx={{ marginTop: { xs: '20px', md: '0px' } }}>
            Main
            <hr style={{ width: '40px', margin: '5px 0px 20px 0px' }} />
            <a style={{ cursor: 'pointer' }} onClick={() => component.toggleNewsletterModal(true)}>
              Weekly update
            </a>
            <p style={{ margin: '3px' }} />
            <Link href="/companies" as="/companies">
              Companies
            </Link>
            <p style={{ margin: '3px' }} />
            <Link href="/recruit" as="/recruit">
              Recruit
            </Link>
            <p style={{ margin: '3px' }} />
            <Link href="/promote" as="/promote">
              Promote
            </Link>
            <p style={{ margin: '3px' }} />
            <a href="https://workintalent.com?ref=wib" target="_blank" rel="noopener noreferrer">
              Work In Talent
            </a>
            <p style={{ margin: '3px' }} />
            <a href="https://findharbor.com?ref=wib" target="_blank" rel="noopener noreferrer">
              Harbor ATS/CRM
            </a>
          </Box>
        </Grid>
        <Grid item md={6} xs={12}>
          <Box sx={{ marginTop: { xs: '20px', md: '0px' }, marginBottom: '20px' }}>
            <span>{`© ${new Date().getFullYear()} Work In Biotech LLC`}</span>
            <hr style={{ width: '250px', margin: '5px 0px 20px 0px' }} />
            <a onClick={component.showHomepageModal} style={{ cursor: 'pointer' }}>
              Personal data
            </a>
            <p style={{ margin: '3px' }} />
            <Link href="/terms" as="/terms">
              Terms of Service
            </Link>
            <p style={{ margin: '3px' }} />
            <Link href="/privacy" as="/privacy">
              Privacy Policy
            </Link>
            <p style={{ margin: '3px' }} />
            Contact: recruit@workinbiotech.com
          </Box>
        </Grid>
      </Grid>
      <HomepageModal open={openHomepageModal} onClose={component.handleHomepageModalClose} />
      <WeeklyUpdateModal open={openNewsletterModal} onClose={component.handleWeeklyUpdateModalClose} />
      <Notifier />
      <Confirmer />
    </div>
  );
}

type Props = {
  children: React.ReactNode;
  currentRoute?: string;
  isThemeDark?: boolean;
};

type State = {
  open: boolean;
  openNewsletterModal: boolean;
  openHomepageModal: boolean;
};

class Layout extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      openNewsletterModal: false,
      openHomepageModal: false,
    };
  }

  public handleHomepageModalClose = () => {
    this.setState({ openHomepageModal: false });
  };

  public showHomepageModal = () => {
    this.setState({ openHomepageModal: true });
  };

  public toggleDrawer = (open: boolean): void => {
    this.setState({ open });
  };

  public toggleNewsletterModal = (openNewsletterModal: boolean): void => {
    this.setState({ openNewsletterModal, open: false });
  };

  public handleWeeklyUpdateModalClose = () => {
    this.setState({ openNewsletterModal: false });
  };

  public render() {
    const { children, currentRoute, isThemeDark } = this.props;

    return (
      <LayoutWrapper
        isThemeDark={isThemeDark}
        currentRoute={currentRoute}
        open={this.state.open}
        openNewsletterModal={this.state.openNewsletterModal}
        openHomepageModal={this.state.openHomepageModal}
        component={this}
      >
        <Grid item sm={12} xs={12}>
          {children}
        </Grid>
      </LayoutWrapper>
    );
  }
}

export default Layout;
